export default __webpack_public_path__ + "static/media/010_home.av1.357f012e.mp4";